import { render, staticRenderFns } from "./LessonAssignment.vue?vue&type=template&id=609e775c&scoped=true&"
import script from "./LessonAssignment.vue?vue&type=script&lang=js&"
export * from "./LessonAssignment.vue?vue&type=script&lang=js&"
import style0 from "./LessonAssignment.vue?vue&type=style&index=0&id=609e775c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609e775c",
  null
  
)

export default component.exports